import { component$, Slot } from "@builder.io/qwik";
import { cn } from "~/lib/cn";

interface ColumnsProps {
  count?: "1" | "2" | "3" | "4";
}

const COUNT_CLASSES = {
  "1": "md:grid-cols-1",
  "2": "md:grid-cols-2",
  "3": "md:grid-cols-3",
  "4": "md:grid-cols-4",
};

export const Columns = component$<ColumnsProps>(({ count = "1" }) => (
  <div class={cn("grid items-stretch gap-4", COUNT_CLASSES[count])}>
    <Slot />
  </div>
));
